import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaFilm,
  FaGavel,
  FaMoneyBillWave,
  FaTheaterMasks,
  FaShieldAlt,
  FaExclamationTriangle,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailActu2 = () => {
  const article = {
    id: 2,
    title:
      "Décryptage de la Loi 2026-01 : La révolution de l'industrie du cinéma et de l'image animée au Bénin",
    excerpt:
      "Promulguée le 03 février 2026, la loi n° 2026-01 portant industrie du cinéma et de l'image animée en République du Bénin marque un tournant décisif. Elle vise à transformer un secteur jusqu'ici artisanal en une véritable \"industrie de l'écran\", capable de générer de la valeur, de créer des emplois et de rayonner à l'international.",
    category: "Actualités",
    date: "03 Février 2026",
    author: "CINEF-EC",
    readTime: "6 min",
    tags: [
      "#CINEF",
      "#Benin",
      "#CinemaBeninois",
      "#Team229",
      "#Audiovisuel",
      "#FinancementCinema",
      "#Fiscalite",
      "#OHADA",
      "#Producteur",
      "#Realisateur",
      "#ExploitantCinema",
      "#ExpertiseComptable",
      "#CINEFExpertise",
      "#ConseilFinancier",
      "#OECCA",
      "#Gestion",
    ],
  };

  const sections = [
    {
      id: 1,
      icon: <FaFilm />,
      title: "La professionnalisation des acteurs et l'encadrement des tournages",
      content: `La loi met fin à l'improvisation en instaurant des règles strictes pour l'exercice des métiers du cinéma :`,
      items: [
        {
          label: "La Carte professionnelle :",
          text: "Toute personne physique désirant exercer dans cette industrie doit désormais détenir une carte professionnelle délivrée par le directeur chargé de la cinématographie. Elle est octroyée sur la base d'une formation reconnue par l'État ou d'une expérience/d'un talent avéré.",
        },
        {
          label: "Priorité à l'emploi local :",
          text: "Les producteurs opérant au Bénin ont l'obligation d'utiliser en priorité les services des professionnels béninois détenteurs de cette carte.",
        },
        {
          label: "Autorisation de tournage :",
          text: "Fini les tournages sauvages. Une autorisation préalable est exigée. De plus, le travail des enfants acteurs de moins de 14 ans est strictement encadré (autorisation parentale et autorisation spéciale du ministre du travail requises).",
        },
      ],
      highlight: null,
    },
    {
      id: 2,
      icon: <FaMoneyBillWave />,
      title: "Le nerf de la guerre : Financement, Fiscalité et Douane",
      content: `C'est ici que le bât blesse souvent dans la création cinématographique. L'État béninois a prévu des leviers puissants pour soutenir la production, tout en instaurant des mécanismes de prélèvement.`,
      items: [
        {
          label: "Le Fonds de soutien au développement du cinéma :",
          text: "Ce compte d'affectation spéciale est créé pour subventionner la production, la distribution et la modernisation des salles. Il sera alimenté par des pourcentages sur les recettes d'exploitation, des subventions, et une contribution obligatoire des diffuseurs.",
        },
        {
          label: "Des exonérations douanières majeures :",
          text: "Les équipements et fournitures destinés à un film produit ou réalisé au Bénin bénéficient d'une exonération de droits de douane à l'entrée et à la sortie du territoire, à condition d'être signalés d'avance.",
        },
        {
          label: "La redevance de promotion cinématographique :",
          text: "Les importateurs et distributeurs de films commerciaux et de matériel professionnel y sont désormais assujettis.",
        },
      ],
      highlight: {
        text: "L'accès au Fonds de soutien et aux exonérations exigera une rigueur comptable absolue. Notre cabinet vous accompagne pour monter des dossiers de financement (budgets, plans de trésorerie) conformes aux exigences de l'administration et pour optimiser le traitement fiscal de vos importations de matériel.",
      },
    },
    {
      id: 3,
      icon: <FaTheaterMasks />,
      title: "Exploitation en salle : Digitalisation, transparence et protection du public",
      content: `Les salles de cinéma font l'objet d'une attention particulière pour garantir la sécurité du public et la transparence des revenus générés :`,
      items: [
        {
          label: "Traçabilité des recettes :",
          text: "L'exploitation des salles doit obligatoirement s'effectuer via un logiciel homologué et interopérable avec les systèmes d'informations de l'Administration publique. Une taxe sur la billetterie sera reversée à l'État.",
        },
        {
          label: "Visa d'exploitation :",
          text: "Aucune œuvre ne peut être projetée en salle ou diffusée dans les médias sans un visa préalable.",
        },
        {
          label: "Assurance et Sécurité :",
          text: "L'exploitant a l'obligation de souscrire une assurance responsabilité civile. De plus, l'accès des mineurs est strictement interdit pour les œuvres comportant des scènes de violence ou à caractère sexuel explicite, avec obligation d'affichage clair de ces interdictions.",
        },
      ],
      highlight: null,
    },
    {
      id: 4,
      icon: <FaGavel />,
      title: "Patrimoine et Sécurité Juridique (OHADA)",
      content: `Un film est un actif immatériel de grande valeur. La loi 2026-01 met en place les outils pour le protéger :`,
      items: [
        {
          label: "Le Registre public de la cinématographie :",
          text: "Tenu par un conservateur, il permet d'immatriculer les films et d'y inscrire les cessions de droits, les contrats de distribution ou les nantissements. Faute d'inscription, ces droits ne sont pas opposables aux tiers.",
        },
        {
          label: "Arrimage au droit OHADA :",
          text: "Fait majeur pour les investisseurs, la constitution de sûretés (garanties) sur les œuvres audiovisuelles est expressément soumise à l'Acte uniforme de l'OHADA.",
        },
        {
          label: "Le Dépôt légal et la Cinémathèque :",
          text: "Pour préserver la mémoire du pays, les œuvres produites, importées ou diffusées sont soumises au dépôt légal. La Cinémathèque nationale aura pour rôle de conserver et restaurer ce patrimoine.",
        },
      ],
      highlight: {
        text: "Inscrire vos droits au registre public ou nantir une œuvre pour lever des fonds nécessite une évaluation financière précise de vos actifs immatériels. Nos experts maîtrisent l'ingénierie financière liée au droit OHADA pour sécuriser vos partenariats.",
      },
    },
    {
      id: 5,
      icon: <FaExclamationTriangle />,
      title: "Sanctions et Période de Transition",
      content: `Le non-respect de ces dispositions expose les contrevenants à de lourdes sanctions : fermetures administratives de salles (notamment pour défaut d'assurance), saisie de matériel, et des amendes allant jusqu'à 10 millions de FCFA, voire des peines de prison pour les tournages non autorisés.`,
      items: [],
      transition: true,
      highlight: null,
    },
  ];

  const similarArticles = [
    {
      id: 3,
      title: "Comment optimiser la comptabilité de votre TPE en 2025",
      image: "/assets/images/image2.png",
      date: "5 avril 2025",
      category: "Comptabilité",
    },
    {
      id: 5,
      title: "Les enjeux de la RSE pour les PME en 2025",
      image: "/assets/images/image6.png",
      date: "20 mars 2025",
      category: "RSE",
    },
  ];

  return (
    <>
      <Header />

      <div className="article-page">
        {/* Hero Banner */}
        <div className="article-hero">
          <div className="container hero-inner">
            <div className="hero-text-col">
              <span className="category-pill">{article.category}</span>
              <h1 className="hero-title">{article.title}</h1>
              <div className="hero-meta">
                <span><FaCalendarAlt className="icon" />{article.date}</span>
                <span className="dot">·</span>
                <span><FaUser className="icon" />{article.author}</span>
                <span className="dot">·</span>
                <span><FaClock className="icon" />{article.readTime} de lecture</span>
              </div>
            </div>
            <div className="hero-img-col">
              <img
                src="../assets/images/loi_cine.jpg"
                alt={article.title}
                className="hero-img"
              />
              <div className="hero-img-badge">🎬 Loi n° 2026-01 — Bénin, février 2026</div>
            </div>
          </div>
        </div>

        <div className="container article-layout">
          <div className="main-col">
            {/* Intro */}
            <div className="intro-block">
              <div className="intro-accent" />
              <p className="intro-text">{article.excerpt}</p>
              <p className="intro-sub">
                Que vous soyez technicien, réalisateur, producteur ou exploitant de salle, cette loi redéfinit entièrement votre cadre de travail. Le cabinet <strong>CINEF-EXPERTISE COMPTABLE</strong> vous propose une analyse en profondeur de ces nouvelles dispositions pour vous aider à anticiper cette mutation.
              </p>
            </div>

            {/* Table of contents pills */}
            <div className="toc-row">
              {sections.map((s) => (
                <a key={s.id} href={`#section-${s.id}`} className="toc-pill">
                  <span className="toc-num">{s.id}</span>
                  <span className="toc-label">
                    {s.id === 1 && "Professionnalisation"}
                    {s.id === 2 && "Financement & Fiscalité"}
                    {s.id === 3 && "Exploitation en salle"}
                    {s.id === 4 && "Patrimoine & OHADA"}
                    {s.id === 5 && "Sanctions & Transition"}
                  </span>
                </a>
              ))}
            </div>

            {/* Sections */}
            {sections.map((section) => (
              <div key={section.id} id={`section-${section.id}`} className={`section-card ${section.transition ? "section-warning" : ""}`}>
                <div className="section-header">
                  <div className={`section-icon-wrap ${section.transition ? "icon-warn" : ""}`}>
                    {section.icon}
                  </div>
                  <div className="section-num">{String(section.id).padStart(2, "0")}</div>
                  <h2 className="section-title">{section.title}</h2>
                </div>

                {section.content && (
                  <p className="section-intro">{section.content}</p>
                )}

                {section.transition && (
                  <div className="transition-box">
                    <div className="transition-badge">⏱ 12 mois</div>
                    <p>Toutefois, le législateur a prévu une phase d'adaptation : <strong>les acteurs déjà en activité disposent d'un délai de douze mois (12 mois) à compter de l'entrée en vigueur de la loi pour se conformer à ces nouvelles exigences.</strong></p>
                  </div>
                )}

                {section.items.length > 0 && (
                  <ul className="section-list">
                    {section.items.map((item, i) => (
                      <li key={i} className="section-list-item">
                        <div className="list-bullet" />
                        <div className="list-text">
                          <strong>{item.label}</strong> {item.text}
                        </div>
                      </li>
                    ))}
                  </ul>
                )}

                {section.highlight && (
                  <div className="expert-callout">
                    <div className="callout-header">
                      <span className="callout-logo">💡</span>
                      <span>L'éclairage de CINEF-EXPERTISE COMPTABLE</span>
                    </div>
                    <p className="callout-body">{section.highlight.text}</p>
                  </div>
                )}
              </div>
            ))}

            {/* CTA */}
            <div className="cta-block">
              <div className="cta-deco" />
              <div className="cta-content">
                <FaShieldAlt className="cta-icon" />
                <h3 className="cta-title">Ne restez pas en marge de cette révolution !</h3>
                <p className="cta-text">
                  L'industrie cinématographique béninoise entre dans une ère de structuration sans précédent. Pour transformer ces nouvelles obligations en véritables avantages concurrentiels, un accompagnement administratif, financier et comptable est indispensable.
                </p>
                <p className="cta-bold">
                  Prêts à franchir le cap des 12 mois de transition en toute sérénité ? Contactez <strong>votre expert-comptable</strong> dès aujourd'hui pour un audit de votre structure et la mise en conformité de vos activités de production ou d'exploitation.
                </p>
                <div className="cta-links">
                  <p className="cta-links-label">Pour lire l'intégralité de la loi et aller plus loin :</p>
                  <a href="https://sgg.gouv.bj/doc/loi-2026-01/" target="_blank" rel="noopener noreferrer" className="cta-link-btn">
                    📄 Loi N° 2026-01 du 03 février 2026
                  </a>
                  <a href="https://sgg.gouv.bj/" target="_blank" rel="noopener noreferrer" className="cta-link-btn secondary">
                    🌐 sgg.gouv.bj
                  </a>
                </div>
              </div>
            </div>

            {/* Tags */}
            <div className="tags-section">
              <span className="tags-label">Tags :</span>
              <div className="tags-wrap">
                {article.tags.map((tag, i) => (
                  <span key={i} className="tag-chip">{tag}</span>
                ))}
              </div>
            </div>

            {/* Share */}
            <div className="share-bar">
              <span className="share-label">Partager cet article</span>
              <div className="share-buttons">
                <a href="#" className="share-btn linkedin"><FaLinkedin /></a>
                <a href="#" className="share-btn twitter"><FaTwitter /></a>
                <a href="#" className="share-btn facebook"><FaFacebook /></a>
              </div>
            </div>

            {/* Back */}
            <div className="back-row">
              <Link to="/actualites" className="btn-back">
                <FaChevronLeft className="me-2" /> Retour aux actualités
              </Link>
            </div>
          </div>

          {/* Sidebar */}
          <aside className="sidebar-col">
            <div className="sidebar-widget">
              <h4 className="widget-title">À propos de l'auteur</h4>
              <div className="author-card">
                <div className="author-avatar">
                  <img src="../assets/images/image3.png" alt={article.author} />
                </div>
                <h5 className="author-name">{article.author}</h5>
                <p className="author-bio">
                  Cabinet d'expertise comptable spécialisé dans l'accompagnement des entreprises et des secteurs créatifs en Afrique francophone.
                </p>
              </div>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">Articles similaires</h4>
              <div className="similar-list">
                {similarArticles.map((a) => (
                  <Link key={a.id} to={`/actualites/${a.id}`} className="similar-item">
                    <div className="similar-img-wrap">
                      <img src={a.image} alt={a.title} />
                      <span className="similar-cat">{a.category}</span>
                    </div>
                    <div className="similar-info">
                      <p className="similar-title">{a.title}</p>
                      <span className="similar-date"><FaCalendarAlt size={10} /> {a.date}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            <div className="sidebar-widget newsletter-widget">
              <h4 className="widget-title">Newsletter</h4>
              <p className="newsletter-desc">Restez informé des dernières actualités fiscales et comptables</p>
              <div className="newsletter-form">
                <input type="email" placeholder="Votre adresse email" className="newsletter-input" />
                <button className="newsletter-btn">S'abonner</button>
              </div>
            </div>

            {/* Loi Quick Ref */}
            <div className="sidebar-widget quickref-widget">
              <h4 className="widget-title">Références légales</h4>
              <div className="ref-item">
                <span className="ref-icon">📋</span>
                <div>
                  <p className="ref-title">Loi N° 2026-01</p>
                  <a href="https://sgg.gouv.bj/doc/loi-2026-01/" target="_blank" rel="noopener noreferrer" className="ref-link">Consulter le texte officiel →</a>
                </div>
              </div>
              <div className="ref-item">
                <span className="ref-icon">🏛️</span>
                <div>
                  <p className="ref-title">Secrétariat Général du Gouvernement</p>
                  <a href="https://sgg.gouv.bj/" target="_blank" rel="noopener noreferrer" className="ref-link">sgg.gouv.bj →</a>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500;600;700&display=swap");

        :root {
          --red: #dc3545;
          --green: #198754;
          --dark: #1a1a1a;
          --dark2: #4a4a4a;
          --gray: #6c757d;
          --gray-light: #e9ecef;
          --border: #dee2e6;
          --white: #ffffff;
          --font-body: "DM Sans", sans-serif;
          --font-display: "DM Serif Display", Georgia, serif;
          --shadow-sm: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);
          --shadow-md: 0 4px 16px rgba(0,0,0,0.08);
          --shadow-lg: 0 12px 32px rgba(0,0,0,0.1);
          --tr: all 0.25s cubic-bezier(0.4,0,0.2,1);
        }

        .article-page {
          font-family: var(--font-body);
          color: var(--dark);
          background: #fafafa;
          margin-top: 54px;
        }

        /* ─── HERO ─── */
        .article-hero {
          background: linear-gradient(135deg, #dc3545 0%, #198754 100%);
          padding: 3rem 0;
          overflow: hidden;
        }
        .hero-inner {
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 2.5rem;
          align-items: center;
        }
        @media (max-width: 900px) {
          .hero-inner { grid-template-columns: 1fr; }
          .hero-img-col { display: none; }
        }
        .hero-text-col { padding: 0.5rem 0; }
        .hero-img-col {
          position: relative;
        }
        .hero-img {
          width: 100%;
          height: 220px;
          object-fit: cover;
          border-radius: 14px;
          box-shadow: 0 12px 32px rgba(0,0,0,0.25);
          display: block;
        }
        .hero-img-badge {
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          background: rgba(0,0,0,0.55);
          color: rgba(255,255,255,0.85);
          font-size: 0.72rem;
          padding: 0.45rem 0.75rem;
          border-radius: 0 0 14px 14px;
          letter-spacing: 0.3px;
        }
        .category-pill {
          display: inline-block;
          background: linear-gradient(135deg, var(--red), var(--green));
          color: #fff;
          padding: 0.35rem 1.1rem;
          border-radius: 50px;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 1.25rem;
        }
        .hero-title {
          font-family: var(--font-display);
          font-size: clamp(1.6rem, 3vw, 2.5rem);
          color: #fff;
          line-height: 1.25;
          max-width: 780px;
          margin-bottom: 1.5rem;
          letter-spacing: -0.02em;
        }
        .hero-meta {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 0.5rem 1rem;
          color: rgba(255,255,255,0.6);
          font-size: 0.85rem;
          font-weight: 500;
        }
        .hero-meta .icon { margin-right: 5px; color: rgba(255,255,255,0.4); }
        .hero-meta .dot { color: rgba(255,255,255,0.3); }

        /* ─── LAYOUT ─── */
        .article-layout {
          display: grid;
          grid-template-columns: 1fr 320px;
          gap: 2.5rem;
          padding-top: 2.5rem;
          padding-bottom: 4rem;
          align-items: start;
        }
        @media (max-width: 1024px) {
          .article-layout { grid-template-columns: 1fr; }
        }

        /* ─── INTRO ─── */
        .intro-block {
          display: flex;
          gap: 1.25rem;
          background: linear-gradient(135deg, rgba(220,53,69,0.04) 0%, rgba(25,135,84,0.04) 100%);
          border-radius: 12px;
          padding: 1.75rem;
          margin-bottom: 2rem;
          border: 1px solid rgba(220,53,69,0.12);
        }
        .intro-accent {
          flex-shrink: 0;
          width: 4px;
          border-radius: 4px;
          background: linear-gradient(to bottom, var(--red), var(--green));
        }
        .intro-text {
          font-size: 1.05rem;
          line-height: 1.75;
          color: #4a4a4a;
          margin: 0 0 0.75rem;
          font-style: italic;
        }
        .intro-sub {
          font-size: 0.95rem;
          line-height: 1.7;
          color: var(--gray);
          margin: 0;
        }

        /* ─── TOC ─── */
        .toc-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;
          margin-bottom: 2.5rem;
        }
        .toc-pill {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          background: #fff;
          border: 1px solid var(--border);
          border-radius: 8px;
          padding: 0.4rem 0.85rem 0.4rem 0.5rem;
          font-size: 0.78rem;
          font-weight: 600;
          color: var(--dark);
          text-decoration: none;
          transition: var(--tr);
          box-shadow: var(--shadow-sm);
        }
        .toc-pill:hover {
          border-color: var(--red);
          color: var(--red);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(220,53,69,0.15);
        }
        .toc-num {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          background: linear-gradient(135deg, var(--red), var(--green));
          color: #fff;
          font-size: 0.68rem;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* ─── SECTION CARDS ─── */
        .section-card {
          background: #fff;
          border-radius: 16px;
          padding: 2rem;
          margin-bottom: 1.5rem;
          border: 1px solid var(--border);
          box-shadow: var(--shadow-sm);
          transition: var(--tr);
          scroll-margin-top: 80px;
        }
        .section-card:hover { box-shadow: var(--shadow-md); }
        .section-warning {
          border-color: rgba(220,53,69,0.25);
          background: linear-gradient(135deg, #fff9f9 0%, #fff 100%);
        }

        .section-header {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          margin-bottom: 1.25rem;
          position: relative;
        }
        .section-icon-wrap {
          width: 44px;
          height: 44px;
          flex-shrink: 0;
          border-radius: 12px;
          background: linear-gradient(135deg, rgba(220,53,69,0.1), rgba(25,135,84,0.1));
          color: var(--green);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.1rem;
          margin-top: 2px;
        }
        .icon-warn { color: var(--red); }
        .section-num {
          position: absolute;
          top: 0;
          right: 0;
          font-family: var(--font-display);
          font-size: 3.5rem;
          color: rgba(0,0,0,0.04);
          line-height: 1;
          user-select: none;
        }
        .section-title {
          font-family: var(--font-display);
          font-size: 1.35rem;
          font-weight: 400;
          line-height: 1.3;
          color: var(--dark);
          margin: 0;
          flex: 1;
        }
        .section-intro {
          font-size: 0.95rem;
          line-height: 1.75;
          color: #4a4a4a;
          margin-bottom: 1.25rem;
        }

        /* ─── LIST ─── */
        .section-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 0.875rem;
        }
        .section-list-item {
          display: flex;
          gap: 0.875rem;
          align-items: flex-start;
          padding: 0.875rem 1rem;
          background: var(--gray-light);
          border-radius: 10px;
          font-size: 0.93rem;
          line-height: 1.7;
          color: #4a4a4a;
          transition: var(--tr);
        }
        .section-list-item:hover { background: #f0fff4; }
        .list-bullet {
          flex-shrink: 0;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: linear-gradient(135deg, var(--red), var(--green));
          margin-top: 8px;
        }

        /* ─── EXPERT CALLOUT ─── */
        .expert-callout {
          margin-top: 1.25rem;
          background: linear-gradient(135deg, #f0fff4 0%, #fff 100%);
          border: 1px solid rgba(25,135,84,0.25);
          border-radius: 12px;
          overflow: hidden;
        }
        .callout-header {
          display: flex;
          align-items: center;
          gap: 0.6rem;
          background: linear-gradient(135deg, var(--green), #146c43);
          color: #fff;
          padding: 0.6rem 1rem;
          font-size: 0.8rem;
          font-weight: 700;
          letter-spacing: 0.3px;
        }
        .callout-logo { font-size: 1rem; }
        .callout-body {
          padding: 1rem 1.25rem;
          font-size: 0.9rem;
          line-height: 1.75;
          color: #146c43;
          margin: 0;
          font-style: italic;
        }

        /* ─── TRANSITION BOX ─── */
        .transition-box {
          position: relative;
          background: linear-gradient(135deg, rgba(220,53,69,0.05), rgba(220,53,69,0.02));
          border: 1px dashed rgba(220,53,69,0.35);
          border-radius: 12px;
          padding: 1.25rem 1.5rem 1.25rem 4rem;
          margin: 1rem 0;
          font-size: 0.93rem;
          line-height: 1.75;
          color: #4a4a4a;
        }
        .transition-badge {
          position: absolute;
          left: -1px;
          top: 50%;
          transform: translateY(-50%);
          writing-mode: vertical-rl;
          background: linear-gradient(to bottom, var(--red), #a71d2a);
          color: #fff;
          font-size: 0.65rem;
          font-weight: 700;
          letter-spacing: 1.5px;
          padding: 0.8rem 0.35rem;
          border-radius: 12px 0 0 12px;
          text-transform: uppercase;
        }
        .transition-box p { margin: 0; }

        /* ─── CTA ─── */
        .cta-block {
          position: relative;
          background: linear-gradient(135deg, #dc3545 0%, #198754 100%);
          border-radius: 20px;
          padding: 2.5rem;
          margin: 2rem 0;
          overflow: hidden;
          color: #fff;
        }
        .cta-deco {
          position: absolute;
          top: -60px;
          right: -60px;
          width: 200px;
          height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(220,53,69,0.2) 0%, transparent 70%);
          pointer-events: none;
        }
        .cta-content { position: relative; z-index: 1; }
        .cta-icon {
          font-size: 2rem;
          color: var(--green);
          margin-bottom: 1rem;
          display: block;
        }
        .cta-title {
          font-family: var(--font-display);
          font-size: 1.5rem;
          margin-bottom: 1rem;
          line-height: 1.3;
        }
        .cta-text {
          font-size: 0.95rem;
          line-height: 1.75;
          color: rgba(255,255,255,0.7);
          margin-bottom: 1rem;
        }
        .cta-bold {
          font-size: 0.95rem;
          line-height: 1.75;
          color: rgba(255,255,255,0.9);
          margin-bottom: 1.5rem;
          padding: 1rem;
          border-left: 3px solid var(--green);
          background: rgba(25,135,84,0.1);
          border-radius: 0 8px 8px 0;
        }
        .cta-links { }
        .cta-links-label {
          font-size: 0.85rem;
          color: rgba(255,255,255,0.5);
          margin-bottom: 0.75rem;
        }
        .cta-link-btn {
          display: inline-block;
          margin-right: 0.75rem;
          margin-bottom: 0.5rem;
          background: rgba(255,255,255,0.1);
          border: 1px solid rgba(255,255,255,0.2);
          color: #fff;
          padding: 0.5rem 1rem;
          border-radius: 8px;
          font-size: 0.85rem;
          font-weight: 600;
          text-decoration: none;
          transition: var(--tr);
        }
        .cta-link-btn:hover { background: var(--green); border-color: var(--green); }
        .cta-link-btn.secondary:hover { background: rgba(255,255,255,0.2); border-color: rgba(255,255,255,0.4); }

        /* ─── TAGS ─── */
        .tags-section {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0.5rem;
          margin: 1.5rem 0;
        }
        .tags-label { font-size: 0.82rem; font-weight: 700; color: var(--gray); text-transform: uppercase; letter-spacing: 0.5px; }
        .tags-wrap { display: flex; flex-wrap: wrap; gap: 0.4rem; }
        .tag-chip {
          background: var(--gray-light);
          color: var(--gray);
          font-size: 0.75rem;
          font-weight: 600;
          padding: 0.25rem 0.65rem;
          border-radius: 50px;
          border: 1px solid var(--border);
          transition: var(--tr);
        }
        .tag-chip:hover { background: var(--dark); color: #fff; border-color: var(--dark); }

        /* ─── SHARE ─── */
        .share-bar {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.25rem 1.5rem;
          background: #fff;
          border-radius: 12px;
          border: 1px solid var(--border);
          margin-bottom: 1.5rem;
        }
        .share-label { font-size: 0.85rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: var(--gray); }
        .share-buttons { display: flex; gap: 0.6rem; }
        .share-btn {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-decoration: none;
          font-size: 1rem;
          transition: var(--tr);
        }
        .share-btn:hover { transform: translateY(-3px) scale(1.05); }
        .linkedin { background: #0077b5; }
        .twitter { background: #1da1f2; }
        .facebook { background: #4267b2; }

        /* ─── BACK ─── */
        .back-row { margin-bottom: 2rem; }
        .btn-back {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: #fff;
          color: var(--dark);
          padding: 0.75rem 1.5rem;
          border-radius: 50px;
          text-decoration: none;
          box-shadow: var(--shadow-sm);
          border: 1px solid var(--border);
          font-weight: 600;
          font-size: 0.9rem;
          transition: var(--tr);
        }
        .btn-back:hover {
          background: var(--red);
          color: #fff;
          border-color: var(--red);
          transform: translateX(-6px);
          box-shadow: 0 4px 16px rgba(220,53,69,0.25);
        }

        /* ─── SIDEBAR ─── */
        .sidebar-col { display: flex; flex-direction: column; gap: 0; }
        .sidebar-widget {
          background: #fff;
          border-radius: 16px;
          padding: 1.75rem;
          margin-bottom: 1.5rem;
          border: 1px solid var(--border);
          box-shadow: var(--shadow-sm);
          transition: var(--tr);
        }
        .sidebar-widget:hover { box-shadow: var(--shadow-md); }
        .widget-title {
          font-family: var(--font-display);
          font-size: 1.15rem;
          font-weight: 400;
          margin-bottom: 1.25rem;
          padding-bottom: 0.75rem;
          border-bottom: 2px solid var(--border);
          color: var(--dark);
          position: relative;
        }
        .widget-title::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 40px;
          height: 2px;
          background: linear-gradient(to right, var(--red), var(--green));
        }

        .author-card { text-align: center; }
        .author-avatar {
          width: 72px;
          height: 72px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 0.875rem;
          border: 3px solid transparent;
          background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, var(--red), var(--green)) border-box;
        }
        .author-avatar img { width: 100%; height: 100%; object-fit: cover; }
        .author-name { font-size: 1rem; font-weight: 700; margin-bottom: 0.4rem; color: var(--dark); }
        .author-bio { font-size: 0.82rem; color: var(--gray); line-height: 1.6; margin: 0; }

        .similar-list { display: flex; flex-direction: column; gap: 1rem; }
        .similar-item {
          display: flex;
          gap: 0.875rem;
          text-decoration: none;
          color: inherit;
          background: var(--gray-light);
          border-radius: 12px;
          overflow: hidden;
          transition: var(--tr);
          border: 1px solid transparent;
        }
        .similar-item:hover { border-color: var(--red); transform: translateX(4px); box-shadow: var(--shadow-md); }
        .similar-img-wrap {
          width: 90px;
          height: 80px;
          flex-shrink: 0;
          position: relative;
          overflow: hidden;
        }
        .similar-img-wrap img { width: 100%; height: 100%; object-fit: cover; transition: var(--tr); }
        .similar-item:hover .similar-img-wrap img { transform: scale(1.08); }
        .similar-cat {
          position: absolute;
          top: 6px;
          left: 6px;
          background: linear-gradient(135deg, var(--red), var(--green));
          color: #fff;
          font-size: 0.62rem;
          font-weight: 700;
          padding: 0.15rem 0.5rem;
          border-radius: 50px;
        }
        .similar-info { padding: 0.75rem 0.75rem 0.75rem 0; flex: 1; }
        .similar-title { font-size: 0.82rem; font-weight: 600; line-height: 1.4; margin: 0 0 0.4rem; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
        .similar-date { font-size: 0.72rem; color: var(--gray); display: flex; align-items: center; gap: 4px; font-weight: 500; }

        .newsletter-widget { background: linear-gradient(135deg, rgba(220,53,69,0.03) 0%, rgba(25,135,84,0.03) 100%); }
        .newsletter-desc { font-size: 0.85rem; color: var(--gray); line-height: 1.6; margin-bottom: 1rem; }
        .newsletter-form { display: flex; flex-direction: column; gap: 0.6rem; }
        .newsletter-input {
          padding: 0.7rem 1rem;
          border: 1.5px solid var(--border);
          border-radius: 8px;
          font-size: 0.875rem;
          font-family: var(--font-body);
          outline: none;
          transition: var(--tr);
        }
        .newsletter-input:focus { border-color: var(--red); box-shadow: 0 0 0 3px rgba(220,53,69,0.1); }
        .newsletter-btn {
          padding: 0.7rem;
          background: linear-gradient(135deg, var(--red), #a71d2a);
          color: #fff;
          border: none;
          border-radius: 8px;
          font-size: 0.875rem;
          font-weight: 700;
          cursor: pointer;
          font-family: var(--font-body);
          transition: var(--tr);
        }
        .newsletter-btn:hover { background: linear-gradient(135deg, var(--green), #146c43); box-shadow: 0 4px 12px rgba(25,135,84,0.3); }

        .quickref-widget { }
        .ref-item { display: flex; gap: 0.75rem; align-items: flex-start; margin-bottom: 1rem; }
        .ref-item:last-child { margin-bottom: 0; }
        .ref-icon { font-size: 1.2rem; margin-top: 1px; }
        .ref-title { font-size: 0.82rem; font-weight: 700; color: var(--dark); margin: 0 0 0.2rem; }
        .ref-link { font-size: 0.78rem; color: var(--green); text-decoration: none; font-weight: 600; transition: var(--tr); }
        .ref-link:hover { color: var(--red); }

        @media (max-width: 640px) {
          .toc-row { gap: 0.4rem; }
          .toc-label { display: none; }
          .toc-pill { padding: 0.4rem; }
          .section-card { padding: 1.25rem; }
          .cta-block { padding: 1.5rem; }
          .share-bar { flex-direction: column; align-items: flex-start; }
          .article-hero { padding: 3rem 0 2.5rem; }
        }
      `}</style>
    </>
  );
};

export default DetailActu2;